<div class="container-fluid">
    <div class="header-container">
        <div class="page-header"><span class="fa fa-map-signs"></span>Trails</div>
        <div class="loading" *ngIf="loading">
            <div class="loader"></div>
        </div>
    </div>

    <div class="content">
        <div class="row">
            <div style="margin-left: auto!important;margin-right:10px;" pTooltip="Add a new Trail"
                 style="margin-right:32px;margin-left:auto;" tooltipPosition="left"
                 class="fa fa-plus font-button pull-right"
                 (click)="addTrail()"></div>
        </div>
        <div class="margin-top-16">
            <p-table #trailsTable [columns]="columns" [value]="trails" [paginator]="true" [rows]="20">
                <ng-template pTemplate="caption">
                    <div style="text-align: right">
                        <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                        <input type="text" pInputText size="50" placeholder="Search"
                               (input)="trailsTable.filterGlobal($event.target['value'] , 'contains')"
                               style="width:auto">
                        <!--            todo (dcorbett) $event.target.value does not work-->
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th *ngFor="let col of columns" [pSortableColumn]="col.type !== 'action' ? col.field : ''"
                            [ngStyle]="{'width.px': col.field==='packageDescription' ? 300 : 'auto'}">
                            {{col.header}}
                            <p-sortIcon [field]="col.field" style="vertical-align: middle;"
                                        *ngIf="col.type !== 'action'">
                            </p-sortIcon>
                        </th>
                        <th style="width: 60px;"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-trail let-columns="columns">

                    <!--          todo(dcorbett) no bundle [pSelectableRow]="bundle"-->
                    <tr>
                        <td *ngFor="let col of columns">
                            <div>
                                {{trail[col.field]}}
                            </div>
                        </td>
                        <td>
                            <div pTooltip="Edit this Trail" tooltipPosition="left" class="fa fa-pencil font-button"
                                 (click)="openTrail(trail.uniqueID)"></div>
                        </td>

                    </tr>
                </ng-template>
            </p-table>
        </div>

    </div>
</div>

